import store from '@app/plugins/vuex';

export const AuthMixin = {
  computed: {
    $user: {
      get: function () {
        return store.getters['core/auth/user'];
      },

      set: function (val) {
        store.dispatch('core/auth/user', val);
      }
    },

    $config: {
      get: function () {
        return store.getters['core/auth/config'] || {};
      }
    },

    $permission: {
      get: function () {
        return store.getters['core/auth/permissions'] || {};
      }
    },

    $modules: {
      get: function () {
        return store.getters['core/auth/modules'] || {};
      }
    }
  }
};
